import { render, staticRenderFns } from "./confirmationModal.vue?vue&type=template&id=3664a5d2&scoped=true"
import script from "./confirmationModal.vue?vue&type=script&lang=ts"
export * from "./confirmationModal.vue?vue&type=script&lang=ts"
import style0 from "./confirmationModal.vue?vue&type=style&index=0&id=3664a5d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3664a5d2",
  null
  
)

export default component.exports